import React, { lazy, Suspense } from 'react';
import { Spinner } from '@/components';

// Lazy load the heavy RichTextEditor with all Tiptap dependencies
const RichTextEditorComponent = lazy(() =>
  import('./RichTextEditor').then((module) => ({
    default: module.default
  }))
);

// Define the props interface to match the original RichTextEditor
interface LazyRichTextEditorProps {
  content?: string;
  onChange?: (content: string) => void;
  placeholder?: string;
  readOnly?: boolean;
  limit?: number;
  [key: string]: any;
}

export const LazyRichTextEditor: React.FC<LazyRichTextEditorProps> = (props) => {
  return (
    <Suspense
      fallback={
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '200px',
            border: '1px solid #e5e7eb',
            borderRadius: '8px',
            backgroundColor: '#f9fafb'
          }}
        >
          <Spinner size="sm" />
        </div>
      }
    >
      <RichTextEditorComponent {...props} />
    </Suspense>
  );
};
